import axios from '@/libs/api.request'
export const getRoleMapping = (params) => {
  return axios.request({
    url: '/common/role_mapping',
    method: 'GET',
    params
  })
}
export const getDetails = (id) => {
  return axios.request({
    url: `/common/role_mapping/${id}`,
    method: 'GET'
  })
}
export const del = (id) => {
  return axios.request({
    url: `/common/role_mapping/${id}`,
    method: 'DELETE'
  })
}
export const update = (data) => {
  return axios.request({
    url: `/common/role_mapping/${data.role_id}`,
    method: 'PUT',
    data
  })
}
export const add = (data) => {
  return axios.request({
    url: '/common/role_mapping',
    method: 'POST',
    data
  })
}
